import { useMemo, useState } from "react";

export const FEE_EARNER_FIELDS = ["userRef", "displayname"];

function useComboFilter(data, fields, keep) {
  const [term, setTerm] = useState("");

  const filtered = useMemo(() => {
    const search = term.toLowerCase().trim();
    if (!search) return data || [];
    return (data || []).filter(
      (item) =>
        (keep ? keep(item) : false) ||
        fields.some((field) => (item[field] || "").toLowerCase().includes(search)),
    );
  }, [data, fields, keep, term]);

  const onFilterChange = (event) => setTerm(event.filter.value);

  return [filtered, onFilterChange];
}

export default useComboFilter;
